import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Wizard } from 'react-use-wizard';
import { useParams } from 'react-router-dom';
import get from 'lodash/get';
import { history } from 'nallian-shared-ui/lib/config/history';
import { Flex, Loader } from 'nallian-shared-ui/lib/components';
import OnboardingLayout from 'nallian-shared-ui/lib/layout/OnboardingLayout';
import CompleteOrganisation from './steps/completeOrganisation/CompleteOrganisation';
import LegalDocuments from './steps/LegalDocuments';
import completeInvitationService from '../services/completeInvitationService';
import invitationService from '../services/invitationService';
import InvitationError from './InvitationError';
import { PRINCIPAL_STATES } from '../../app/constants';
import InviteComplete from './steps/InviteComplete';

const CompleteInvitation = ({
  dispatchCompleteInvitationPost,
  completeInvitationFetch,
  dispatchInvitationGet,
  invitationFetch,
}) => {
  const { token } = useParams();

  const [data, setData] = useState({});

  useEffect(() => dispatchInvitationGet(token), [dispatchInvitationGet, token]);

  useEffect(() => {
    const principalState = get(invitationFetch.value, 'principal.activeState');
    if (principalState === PRINCIPAL_STATES.INVITED) {
      history.push(`/invite/${token}`);
    }
  }, [invitationFetch.value, token]);

  const handleCompleteInvitation = useCallback(
    (body, callback) => {
      dispatchCompleteInvitationPost(token, body, callback);
    },
    [token, dispatchCompleteInvitationPost]
  );

  if (invitationFetch.pending) {
    return (
      <OnboardingLayout>
        <Loader inline active />
      </OnboardingLayout>
    );
  }

  if (invitationFetch.rejected) {
    return (
      <OnboardingLayout>
        <InvitationError />
      </OnboardingLayout>
    );
  }

  return (
    <OnboardingLayout>
      <Flex fluid direction="column" margin="50px 0 0">
        <Wizard>
          <CompleteOrganisation
            setData={setData}
            invitationFetch={invitationFetch}
            completeInvitationFetch={completeInvitationFetch}
          />
          <LegalDocuments
            data={data}
            invitationFetch={invitationFetch}
            completeInvitationFetch={completeInvitationFetch}
            handleCompleteInvitation={handleCompleteInvitation}
          />
          <InviteComplete invitationFetch={invitationFetch} />
        </Wizard>
      </Flex>
    </OnboardingLayout>
  );
};

CompleteInvitation.propTypes = {
  dispatchCompleteInvitationPost: PropTypes.func.isRequired,
  completeInvitationFetch: PropTypes.object.isRequired,
  dispatchInvitationGet: PropTypes.func.isRequired,
  invitationFetch: PropTypes.object.isRequired,
};

export default compose(invitationService, completeInvitationService)(CompleteInvitation);
